<div class="card p-3 mt-2">
    <nz-skeleton [nzLoading]="loading" [nzActive]="true" class="d-flex flex-column">
        <div class="d-flex flex-column gap-2">
            <div class="title">Customize Appearance</div>
            <span class="text-secondary text-wrap">Customize the default appearance of your checkout page.</span>
        </div>
        <hr>
        <div class="d-flex flex-column flex-lg-row mt-3 gap-4 justify-content-between">
            <div class="d-flex flex-column col-12 col-lg-2">
                <span class="text-bold">Choose Color Template</span>
                <div class="mt-3 d-flex border rounded gap-1 p-1 w-full">
                    <button (click)="switchTab('solid')"
                        [ngClass]="tabValue === 'solid' ? 'btn btn-primary text-white':'btn text-grey'" class="col-6"
                        style="font-size: 12px;">
                        Solid
                    </button>
                    <button (click)="switchTab('custom')"
                        [ngClass]="tabValue === 'custom' ? 'btn btn-primary text-white':'btn text-grey'" class="col-6"
                        style="font-size: 12px;">
                        Custom
                    </button>
                </div>
                <div *ngIf="tabValue === 'solid'" class="mt-3 d-flex flex-column gap-2">
                    <div class="d-flex flex-row gap-2 flex-wrap">
                        @for (color of solidColors.slice(0, 4); track color) {
                        <div class="rounded-circle" style="width: 40px;height: 40px;"
                            [ngStyle]="{'background-color': color}" (click)="changeColor(color)"></div>
                        }
                    </div>
                    <div class="mt-2 d-flex flex-row gap-2 flex-wrap">
                        @for (color of solidColors.slice(4); track color) {
                        <div class="rounded-circle" style="width: 40px;height: 40px;"
                            [ngStyle]="{'background-color': color}" (click)="changeColor(color)"></div>
                        }
                    </div>
                </div>
                <div *ngIf="tabValue === 'custom'" class="mt-3">
                    <color-sketch [color]="customColors" (onChange)="handleChange($event)"></color-sketch>
                </div>
                <div class="mt-4">
                    <span class="text-bold">Upload Logo</span>
                    <div *ngIf="uploadedImage" class="d-flex mt-2" style="height: 60px">
                        <img [src]="uploadedImage" alt="profile" class="rounded"
                            style="max-width: 60px; max-height: 60px; object-fit: cover" />
                    </div>
                    <div class="d-flex gap-1 mb-2 mt-3 col-12 align-items-end">
                        <button *ngIf="!uploadedImage" class="btn btn-outline-primary col-6"
                            (click)="triggerFileInput()">
                            Upload
                        </button>
                        <div *ngIf="uploadedImage" class="d-flex gap-2 align-items-center">
                            <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/paperclip-2.svg"
                                alt="file" style="width: 16px; height: 16px" />
                            <span class="text-wrap col-4">{{ photoName }}</span>
                            <button class="btn p-0" (click)="deleteImage()" [disabled]="!uploadedImage">
                                <img src="https://storage.googleapis.com/komerce/assets/icons/close-circle-red.svg"
                                    alt="delete" style="width: 16px; height: 16px" />
                            </button>
                        </div>
                    </div>
                    <input type="file" name="file" class="form-control d-none" id="attachment"
                        (change)="handleFileUpload($event)" #fileupload />
                </div>
                <div class="mt-4">
                    <span class="text-bold">Company Name</span>
                    <input class="mt-2" nz-input [nzSize]="'large'" [(ngModel)]="companyName"
                        placeholder="Fill company name" maxlength="100"
                        (ngModelChange)="formGroup.get('company_name')?.setValue($event)" />
                </div>
                <div class="d-flex gap-2 mt-4 w-full">
                    <button class="btn btn-outline-secondary col-6" (click)="cancel()">Cancel</button>
                    <button class="btn btn-primary text-white col-6" (click)="saveCustomize()">Save</button>
                </div>
            </div>
            <div class="d-flex flex-column col-12 col-lg-10 px-0 px-lg-4">
                <div class="d-flex flex-lg-row flex-column justify-content-between align-items-start">
                    <span class="text-bold col-6">Preview</span>
                    <div class="d-flex border rounded gap-1 p-1 col-12 col-lg-3">
                        <button (click)="switchTabMode('desktop')"
                            [ngClass]="tabMode === 'desktop' ? 'btn btn-primary text-white':'btn text-grey'"
                            class="col-6">
                            Desktop
                        </button>
                        <button (click)="switchTabMode('mobile')"
                            [ngClass]="tabMode === 'mobile' ? 'btn btn-primary text-white':'btn text-grey'"
                            class="col-6">
                            Mobile
                        </button>
                    </div>
                </div>
                <hr>
                <div class="d-flex flex-column"
                    [ngClass]="tabMode === 'desktop' ? 'flex-column flex-md-row' : 'flex-column align-items-center'"
                    style="height: fit-content;background-color: #F8F8F8;">
                    <div class="d-flex flex-column"
                        [ngClass]="tabMode === 'desktop' ? 'col-12 col-md-5 mt-0' : 'col-12 col-lg-6 mt-lg-5 mt-0 flex align-items-center'">
                        <div class="position-relative" style="width: 100%; max-width: 400px;" [ngStyle]="{
                            'height': (tabMode === 'desktop' ? '100%' : 'auto'),
                            'min-height': (tabMode === 'desktop' ? 'auto' : '70vh')
                        }">
                            <div class="position-absolute w-100" style="top: 0; pointer-events: none;">
                                <img src="https://storage.googleapis.com/komerce/rajaongkir/wave-t.png" alt="wave-top"
                                    style="width: 100%; background-position: center; background-repeat: no-repeat;" />
                            </div>
                            <div class="d-flex flex-column p-4 align-items-start" [ngStyle]="
                                {'background-color': customColors, 
                                'border-radius': (tabMode === 'desktop' ? '20px 0 0 20px' : '0 0 0 0')
                                }" style="width: 100%; height: 100%;">
                                <div class="mt-4 d-flex align-items-center gap-3" style="z-index: 10;">
                                    <div *ngIf="!uploadedImage" class="rounded bg-white w-fit p-2">
                                        <img [src]="
                                        'https://storage.googleapis.com/komerce/assets/LP-Rajaongkir/metadata/icon-192x192.png'
                                    " alt="profile" class="rounded"
                                            style="width: 40px; height: 40px; object-fit: cover" />
                                    </div>
                                    <img *ngIf="uploadedImage" [src]="uploadedImage" alt="profile" class="rounded"
                                        style="width: 80px; height: 80px; object-fit: cover" />
                                    <h5 class="text-white col-8 text-wrap text-break">{{ companyName || 'Raja Ongkir'}}
                                    </h5>
                                </div>
                                <div class="border col-12 mt-4"></div>
                                <div class="mt-4 d-flex flex-column">
                                    <h5 class="text-white text-wrap">Order Detail</h5>
                                    <h6 class="mt-4 text-white text-wrap fw-normal">Payment ID: XX-XXXXX-XXX</h6>
                                    <div class="mt-4 fw-normal d-flex flex-column gap-2">
                                        <span class="text-white text-wrap">Description: XX-XXXXX-XXX</span>
                                        <span class="text-white text-wrap">Customer Name: XX-XXXXX-XXX</span>
                                        <span class="text-white text-wrap">Payment Method: XX-XXXXX-XXX</span>
                                        <span class="text-white text-wrap">Status: XX-XXXXX-XXX</span>
                                        <span class="text-white text-wrap">Order Date: XX-XXXXX-XXX</span>
                                        <span class="text-white text-wrap">Payment Deadline: XX-XXXXX-XXX</span>
                                    </div>
                                </div>
                                <span class="text-white text-wrap mt-auto amount-due-text">
                                    Total Amount Due: XX-XXXX-XXX
                                </span>
                            </div>
                            <div class="position-absolute w-100" style="bottom: 0; pointer-events: none;">
                                <img src="https://storage.googleapis.com/komerce/rajaongkir/wave-b.png" alt="wave-top"
                                    style="width: 100%; background-position: center; background-repeat: no-repeat;" />
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center"
                        [ngClass]="tabMode === 'desktop' ? 'col-12 col-lg-7 col-md-6 p-0 p-md-4' : 'h-fit col-12 col-lg-7 p-0'">
                        <app-payment-bank class="w-100"></app-payment-bank>
                    </div>
                </div>
            </div>
        </div>
    </nz-skeleton>
</div>